<cng-form-hint *ngFor="let warning of warnings" type="danger">
  <span class="message" *ngIf="warning.messages.length > 1">
    <span>{{ warning.messages[0] | translate }} </span>
    <span class="name" title="{{ warning.fileName }}">{{ warning.fileName }} </span>
    <span>{{ warning.messages[1] | translate: { size: maxSize } }}</span>
  </span>
  <span class="message" *ngIf="warning.messages.length === 1">{{ warning.messages[0] | translate: { count: count } }}</span>
  <button mat-icon-button class="cng-ico_annuler" (click)="removeWarning(warning)"></button>
</cng-form-hint>
<div class="attachment" *ngFor="let file of files">
  <chat-attachment [filename]="file.name" [size]="file.size"></chat-attachment>
  <button mat-icon-button (click)="remove(file)" title="{{ 'agent:panel.chat.attachment.remove' | translate }}">
    <mat-icon fontSet="mat">delete</mat-icon>
  </button>
</div>
